import {removeSSOCookies, setTokenExpireTime} from "./utils";
import {clientId, CST_ADMINISTRATIONSERVICE_API_URL, CST_SSOSERVICE_UI_URL} from "../ssoSettings";
import {getServicePromise} from "../Components/HttpService/HttpService";

/* moved from SessionTimer.js */
export const handleLogOut = () => {
    localStorage.clear();
    removeSSOCookies();

    window.location.href = `${CST_SSOSERVICE_UI_URL}/Logout`;
};

export const getAndSaveRefreshToken = () => {
  return new Promise((resolve, reject) => {

      const storageToken = localStorage.getItem("token");
      const storageRefreshToken = localStorage.getItem("refreshToken");

      if (storageRefreshToken && storageRefreshToken !== "" && storageToken && storageToken !== "") {
          getServicePromise(
              CST_ADMINISTRATIONSERVICE_API_URL + `/Token/RefreshAccessToken/`,
              "POST",
              {
                clientId: clientId,
                refreshToken: storageRefreshToken,
              }
          )
              .then((response) => {
          const token = response.token;
          const refreshToken = response.refreshToken;
          localStorage.setItem("token", token);
          localStorage.setItem("refreshToken", refreshToken);

          setTokenExpireTime(token);
          resolve();
        })
        .catch((err) => reject(err));
    }
  });
};
